import * as Yup from 'yup'
import useContactFormValidation from './useContactFormValidation'

export const extractPhoneValidationSchema = (validationSchema: any) => {
  if (validationSchema && validationSchema.fields && validationSchema.fields.phone) {
    return Yup.object().shape({
      phone: validationSchema.fields.phone,
    })
  }
}

export const usePhoneValidationSchema = () => {
  const validationSchema = useContactFormValidation()
  const phoneValidationSchema = extractPhoneValidationSchema(validationSchema)

  return phoneValidationSchema
}
